export const PROJECT_MODES = {
    PREVIEW: 'PREVIEW',
    EDIT: 'EDIT',
    SHARING: 'SHARING',
}
